/* eslint-disable camelcase */

import floor0_1 from './floor0-1.vue';
import floor0_2 from './floor0-2.vue';
import floor0_3 from './floor0-3.vue';

import floor1_1 from './floor1-1.vue';
import floor1_2 from './floor1-2.vue';
import floor1_3 from './floor1-3.vue';
import floor1_4 from './floor1-4.vue';
import floor1_5 from './floor1-5.vue';

import floor2_1 from './floor2-1.vue';
import floor2_2 from './floor2-2.vue';
import floor2_3 from './floor2-3.vue';
import floor2_4 from './floor2-4.vue';

import floor3_1 from './floor3-1.vue';
import floor3_2 from './floor3-2.vue';
import floor3_3 from './floor3-3.vue';
import floor3_4 from './floor3-4.vue';

import floor4_1 from './floor4-1.vue';
import floor4_2 from './floor4-2.vue';
import floor4_3 from './floor4-3.vue';
import floor4_4 from './floor4-4.vue';

import floor5_1 from './floor5-1.vue';
import floor5_2 from './floor5-2.vue';
import floor5_3 from './floor5-3.vue';

import floor6_1 from './floor6-1.vue';
import floor6_2 from './floor6-2.vue';
import floor6_3 from './floor6-3.vue';
import floor6_4 from './floor6-4.vue';

import floor7_1 from './floor7-1.vue';
import floor7_2 from './floor7-2.vue';
import floor7_3 from './floor7-3.vue';
import floor7_4 from './floor7-4.vue';

export default {
    floor0_1,
    floor0_2,
    floor0_3,

    floor1_1,
    floor1_2,
    floor1_3,
    floor1_4,
    floor1_5,

    floor2_1,
    floor2_2,
    floor2_3,
    floor2_4,

    floor3_1,
    floor3_2,
    floor3_3,
    floor3_4,

    floor4_1,
    floor4_2,
    floor4_3,
    floor4_4,

    floor5_1,
    floor5_2,
    floor5_3,

    floor6_1,
    floor6_2,
    floor6_3,
    floor6_4,

    floor7_1,
    floor7_2,
    floor7_3,
    floor7_4
};
